import moment from "moment";
export default function formAPILink({
    chat,
    chattype,
    ispatient,
    createddate,
    imagepath,
   
    
  }) {   
    return Object.freeze({
        chat,
        chattype,
        ispatient,
        createddate,
        imagepath,       
    });
}


  